(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 989px)');
  var isMeasuring = false;
  var scheduled = false;
  var lastHeight = -1;
  var lastActive = null;

  function isMobileStickyContext() {
    return MOBILE_MQ.matches;
  }

  function syncStickyAtcHeight() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(runMeasure);
  }

  function runMeasure() {
    scheduled = false;
    if (isMeasuring) return;
    isMeasuring = true;

    var root = document.documentElement;
    var body = document.body;
    var bar = document.querySelector('.vibee-pdp__module--sticky-atc');

    if (!bar || !isMobileStickyContext()) {
      if (lastHeight !== 0) {
        root.style.setProperty('--sticky-atc-h', '0px');
        lastHeight = 0;
      }
      if (lastActive !== false) {
        body.classList.remove('vibee-pdp-sticky-atc-active');
        lastActive = false;
      }
      bar && bar.classList.remove('is-suppressed');
      isMeasuring = false;
      return;
    }

    var drawerOpen = body.classList.contains('vibee-cart-drawer-open');
    var visible = bar.classList.contains('is-visible') && !drawerOpen;
    var shouldSuppress = drawerOpen;
    var shouldBeActive = visible;

    if (bar.classList.contains('is-suppressed') !== shouldSuppress) {
      bar.classList.toggle('is-suppressed', shouldSuppress);
    }

    var height = 0;
    if (shouldBeActive) {
      height = bar.offsetHeight || 0;
    }

    if (lastHeight !== height) {
      root.style.setProperty('--sticky-atc-h', height + 'px');
      lastHeight = height;
    }

    if (lastActive !== shouldBeActive) {
      body.classList.toggle('vibee-pdp-sticky-atc-active', shouldBeActive);
      lastActive = shouldBeActive;
    }

    isMeasuring = false;
  }

  function init() {
    syncStickyAtcHeight();
    window.addEventListener('resize', syncStickyAtcHeight, { passive: true });
    window.addEventListener('scroll', syncStickyAtcHeight, { passive: true });

    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', syncStickyAtcHeight);
    } else if (typeof MOBILE_MQ.addListener === 'function') {
      MOBILE_MQ.addListener(syncStickyAtcHeight);
    }
  }

  window.vibeeSyncStickyAtcHeight = syncStickyAtcHeight;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
